/**
 * Scroll restoration when returning from listing detail to /bookings.
 */

import { inquiryCardDomId } from './bookingInquiryContext';

export const INQUIRY_CARD_HIGHLIGHT_CLASS = 'booking-inquiry-card-highlight';

const HIGHLIGHT_DURATION_MS = 2500;

/**
 * Scroll inquiry card into view and apply a brief non-aggressive highlight.
 * Returns false when the card element is not in the document.
 */
export function scrollToInquiryCard(focusInquiryId) {
  const elementId = inquiryCardDomId(focusInquiryId);
  if (!elementId || typeof document === 'undefined') {
    return false;
  }

  const element = document.getElementById(elementId);
  if (!element) {
    return false;
  }

  element.scrollIntoView({ behavior: 'smooth', block: 'center' });
  element.classList.add(INQUIRY_CARD_HIGHLIGHT_CLASS);
  element.setAttribute('tabindex', '-1');
  try {
    element.focus({ preventScroll: true });
  } catch {
    // Some browsers reject focus on non-interactive nodes; scroll still applies.
  }

  window.setTimeout(() => {
    element.classList.remove(INQUIRY_CARD_HIGHLIGHT_CLASS);
  }, HIGHLIGHT_DURATION_MS);

  return true;
}

/**
 * Safe no-op when focus id missing or inquiries list does not contain it.
 */
export function shouldRestoreBookingsFocus(focusInquiryId, inquiries) {
  if (!focusInquiryId || !Array.isArray(inquiries) || inquiries.length === 0) {
    return false;
  }
  return inquiries.some(
    (item) => item?.id === focusInquiryId || item?.inquiry_id === focusInquiryId,
  );
}
